// extracted by mini-css-extract-plugin
var _1 = "Posts-moduleheaderWrapper__TbOzQ";
var _2 = "Posts-modulepostsPage__Q4Qvr PageWithWidgets-modulePageWithWidgets__h84KP";
var _3 = "Posts-modulewidgetsWrapper__WwLKh";
export { _1 as "headerWrapper", _2 as "postsPage", _3 as "widgetsWrapper" }
